
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("dMnv2", function(module, exports) {

$parcel$export(module.exports, "default", () => $a081fc9a5ea061da$export$2e2bcd8739ae039);
/**
 * Fuse.js v6.6.2 - Lightweight fuzzy-search (http://fusejs.io)
 *
 * Copyright (c) 2022 Kiro Risk (http://kiro.me)
 * All Rights Reserved. Apache Software License 2.0
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 */ function $a081fc9a5ea061da$var$isArray(value) {
    return !Array.isArray ? $a081fc9a5ea061da$var$getTag(value) === '[object Array]' : Array.isArray(value);
}
// Adapted from: https://github.com/lodash/lodash/blob/master/.internal/baseToString.js
const $a081fc9a5ea061da$var$INFINITY = 1 / 0;
function $a081fc9a5ea061da$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    let result = value + '';
    return result == '0' && 1 / value == -$a081fc9a5ea061da$var$INFINITY ? '-0' : result;
}
function $a081fc9a5ea061da$var$toString(value) {
    return value == null ? '' : $a081fc9a5ea061da$var$baseToString(value);
}
function $a081fc9a5ea061da$var$isString(value) {
    return typeof value === 'string';
}
function $a081fc9a5ea061da$var$isNumber(value) {
    return typeof value === 'number';
}
// Adapted from: https://github.com/lodash/lodash/blob/master/isBoolean.js
function $a081fc9a5ea061da$var$isBoolean(value) {
    return value === true || value === false || $a081fc9a5ea061da$var$isObjectLike(value) && $a081fc9a5ea061da$var$getTag(value) == '[object Boolean]';
}
function $a081fc9a5ea061da$var$isObject(value) {
    return typeof value === 'object';
}
// Checks if `value` is object-like.
function $a081fc9a5ea061da$var$isObjectLike(value) {
    return $a081fc9a5ea061da$var$isObject(value) && value !== null;
}
function $a081fc9a5ea061da$var$isDefined(value) {
    return value !== undefined && value !== null;
}
function $a081fc9a5ea061da$var$isBlank(value) {
    return !value.trim().length;
}
// Gets the `toStringTag` of `value`.
// Adapted from: https://github.com/lodash/lodash/blob/master/.internal/getTag.js
function $a081fc9a5ea061da$var$getTag(value) {
    return value == null ? value === undefined ? '[object Undefined]' : '[object Null]' : Object.prototype.toString.call(value);
}
const $a081fc9a5ea061da$var$EXTENDED_SEARCH_UNAVAILABLE = 'Extended search is not available';
const $a081fc9a5ea061da$var$INCORRECT_INDEX_TYPE = "Incorrect 'index' type";
const $a081fc9a5ea061da$var$LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY = (key)=>`Invalid value for key ${key}`;
const $a081fc9a5ea061da$var$PATTERN_LENGTH_TOO_LARGE = (max)=>`Pattern length exceeds max of ${max}.`;
const $a081fc9a5ea061da$var$MISSING_KEY_PROPERTY = (name)=>`Missing ${name} property in key`;
const $a081fc9a5ea061da$var$INVALID_KEY_WEIGHT_VALUE = (key)=>`Property 'weight' in key '${key}' must be a positive integer`;
const $a081fc9a5ea061da$var$hasOwn = Object.prototype.hasOwnProperty;
class $a081fc9a5ea061da$var$KeyStore {
    constructor(keys){
        this._keys = [];
        this._keyMap = {};
        let totalWeight = 0;
        keys.forEach((key)=>{
            let obj = $a081fc9a5ea061da$var$createKey(key);
            totalWeight += obj.weight;
            this._keys.push(obj);
            this._keyMap[obj.id] = obj;
            totalWeight += obj.weight;
        });
        // Normalize weights so that their sum is equal to 1
        this._keys.forEach((key)=>{
            key.weight /= totalWeight;
        });
    }
    get(keyId) {
        return this._keyMap[keyId];
    }
    keys() {
        return this._keys;
    }
    toJSON() {
        return JSON.stringify(this._keys);
    }
}
function $a081fc9a5ea061da$var$createKey(key) {
    let path = null;
    let id = null;
    let src = null;
    let weight = 1;
    let getFn = null;
    if ($a081fc9a5ea061da$var$isString(key) || $a081fc9a5ea061da$var$isArray(key)) {
        src = key;
        path = $a081fc9a5ea061da$var$createKeyPath(key);
        id = $a081fc9a5ea061da$var$createKeyId(key);
    } else {
        if (!$a081fc9a5ea061da$var$hasOwn.call(key, 'name')) throw new Error($a081fc9a5ea061da$var$MISSING_KEY_PROPERTY('name'));
        const name = key.name;
        src = name;
        if ($a081fc9a5ea061da$var$hasOwn.call(key, 'weight')) {
            weight = key.weight;
            if (weight <= 0) throw new Error($a081fc9a5ea061da$var$INVALID_KEY_WEIGHT_VALUE(name));
        }
        path = $a081fc9a5ea061da$var$createKeyPath(name);
        id = $a081fc9a5ea061da$var$createKeyId(name);
        getFn = key.getFn;
    }
    return {
        path: path,
        id: id,
        weight: weight,
        src: src,
        getFn: getFn
    };
}
function $a081fc9a5ea061da$var$createKeyPath(key) {
    return $a081fc9a5ea061da$var$isArray(key) ? key : key.split('.');
}
function $a081fc9a5ea061da$var$createKeyId(key) {
    return $a081fc9a5ea061da$var$isArray(key) ? key.join('.') : key;
}
function $a081fc9a5ea061da$var$get(obj, path) {
    let list = [];
    let arr = false;
    const deepGet = (obj, path, index)=>{
        if (!$a081fc9a5ea061da$var$isDefined(obj)) return;
        if (!path[index]) // If there's no path left, we've arrived at the object we care about.
        list.push(obj);
        else {
            let key = path[index];
            const value = obj[key];
            if (!$a081fc9a5ea061da$var$isDefined(value)) return;
            // If we're at the last value in the path, and if it's a string/number/bool,
            // add it to the list
            if (index === path.length - 1 && ($a081fc9a5ea061da$var$isString(value) || $a081fc9a5ea061da$var$isNumber(value) || $a081fc9a5ea061da$var$isBoolean(value))) list.push($a081fc9a5ea061da$var$toString(value));
            else if ($a081fc9a5ea061da$var$isArray(value)) {
                arr = true;
                // Search each item in the array.
                for(let i = 0, len = value.length; i < len; i += 1)deepGet(value[i], path, index + 1);
            } else if (path.length) // An object. Recurse further.
            deepGet(value, path, index + 1);
        }
    };
    // Backwards compatibility (since path used to be a string)
    deepGet(obj, $a081fc9a5ea061da$var$isString(path) ? path.split('.') : path, 0);
    return arr ? list : list[0];
}
const $a081fc9a5ea061da$var$MatchOptions = {
    // Whether the matches should be included in the result set. When `true`, each record in the result
    // set will include the indices of the matched characters.
    // These can consequently be used for highlighting purposes.
    includeMatches: false,
    // When `true`, the matching function will continue to the end of a search pattern even if
    // a perfect match has already been located in the string.
    findAllMatches: false,
    // Minimum number of characters that must be matched before a result is considered a match
    minMatchCharLength: 1
};
const $a081fc9a5ea061da$var$BasicOptions = {
    // When `true`, the algorithm continues searching to the end of the input even if a perfect
    // match is found before the end of the same input.
    isCaseSensitive: false,
    // When true, the matching function will continue to the end of a search pattern even if
    includeScore: false,
    // List of properties that will be searched. This also supports nested properties.
    keys: [],
    // Whether to sort the result list, by score
    shouldSort: true,
    // Default sort function: sort by ascending score, ascending index
    sortFn: (a, b)=>a.score === b.score ? a.idx < b.idx ? -1 : 1 : a.score < b.score ? -1 : 1
};
const $a081fc9a5ea061da$var$FuzzyOptions = {
    // Approximately where in the text is the pattern expected to be found?
    location: 0,
    // At what point does the match algorithm give up. A threshold of '0.0' requires a perfect match
    // (of both letters and location), a threshold of '1.0' would match anything.
    threshold: 0.6,
    // Determines how close the match must be to the fuzzy location (specified above).
    // An exact letter match which is 'distance' characters away from the fuzzy location
    // would score as a complete mismatch. A distance of '0' requires the match be at
    // the exact location specified, a threshold of '1000' would require a perfect match
    // to be within 800 characters of the fuzzy location to be found using a 0.8 threshold.
    distance: 100
};
const $a081fc9a5ea061da$var$AdvancedOptions = {
    // When `true`, it enables the use of unix-like search commands
    useExtendedSearch: false,
    // The get function to use when fetching an object's properties.
    // The default will search nested paths *ie foo.bar.baz*
    getFn: $a081fc9a5ea061da$var$get,
    // When `true`, search will ignore `location` and `distance`, so it won't matter
    // where in the string the pattern appears.
    // More info: https://fusejs.io/concepts/scoring-theory.html#fuzziness-score
    ignoreLocation: false,
    // When `true`, the calculation for the relevance score (used for sorting) will
    // ignore the field-length norm.
    // More info: https://fusejs.io/concepts/scoring-theory.html#field-length-norm
    ignoreFieldNorm: false,
    // The weight to determine how much field length norm effects scoring.
    fieldNormWeight: 1
};
var $a081fc9a5ea061da$var$Config = {
    ...$a081fc9a5ea061da$var$BasicOptions,
    ...$a081fc9a5ea061da$var$MatchOptions,
    ...$a081fc9a5ea061da$var$FuzzyOptions,
    ...$a081fc9a5ea061da$var$AdvancedOptions
};
const $a081fc9a5ea061da$var$SPACE = /[^ ]+/g;
// Field-length norm: the shorter the field, the higher the weight.
// Set to 3 decimals to reduce index size.
function $a081fc9a5ea061da$var$norm(weight = 1, mantissa = 3) {
    const cache = new Map();
    const m = Math.pow(10, mantissa);
    return {
        get (value) {
            const numTokens = value.match($a081fc9a5ea061da$var$SPACE).length;
            if (cache.has(numTokens)) return cache.get(numTokens);
            // Default function is 1/sqrt(x), weight makes that variable
            const norm = 1 / Math.pow(numTokens, 0.5 * weight);
            // In place of `toFixed(mantissa)`, for faster computation
            const n = parseFloat(Math.round(norm * m) / m);
            cache.set(numTokens, n);
            return n;
        },
        clear () {
            cache.clear();
        }
    };
}
class $a081fc9a5ea061da$var$FuseIndex {
    constructor({ getFn: getFn = $a081fc9a5ea061da$var$Config.getFn, fieldNormWeight: fieldNormWeight = $a081fc9a5ea061da$var$Config.fieldNormWeight } = {}){
        this.norm = $a081fc9a5ea061da$var$norm(fieldNormWeight, 3);
        this.getFn = getFn;
        this.isCreated = false;
        this.setIndexRecords();
    }
    setSources(docs = []) {
        this.docs = docs;
    }
    setIndexRecords(records = []) {
        this.records = records;
    }
    setKeys(keys = []) {
        this.keys = keys;
        this._keysMap = {};
        keys.forEach((key, idx)=>{
            this._keysMap[key.id] = idx;
        });
    }
    create() {
        if (this.isCreated || !this.docs.length) return;
        this.isCreated = true;
        // List is Array<String>
        if ($a081fc9a5ea061da$var$isString(this.docs[0])) this.docs.forEach((doc, docIndex)=>{
            this._addString(doc, docIndex);
        });
        else // List is Array<Object>
        this.docs.forEach((doc, docIndex)=>{
            this._addObject(doc, docIndex);
        });
        this.norm.clear();
    }
    // Adds a doc to the end of the index
    add(doc) {
        const idx = this.size();
        if ($a081fc9a5ea061da$var$isString(doc)) this._addString(doc, idx);
        else this._addObject(doc, idx);
    }
    // Removes the doc at the specified index of the index
    removeAt(idx) {
        this.records.splice(idx, 1);
        // Change ref index of every subsquent doc
        for(let i = idx, len = this.size(); i < len; i += 1)this.records[i].i -= 1;
    }
    getValueForItemAtKeyId(item, keyId) {
        return item[this._keysMap[keyId]];
    }
    size() {
        return this.records.length;
    }
    _addString(doc, docIndex) {
        if (!$a081fc9a5ea061da$var$isDefined(doc) || $a081fc9a5ea061da$var$isBlank(doc)) return;
        let record = {
            v: doc,
            i: docIndex,
            n: this.norm.get(doc)
        };
        this.records.push(record);
    }
    _addObject(doc, docIndex) {
        let record = {
            i: docIndex,
            $: {}
        };
        // Iterate over every key (i.e, path), and fetch the value at that key
        this.keys.forEach((key, keyIndex)=>{
            let value = key.getFn ? key.getFn(doc) : this.getFn(doc, key.path);
            if (!$a081fc9a5ea061da$var$isDefined(value)) return;
            if ($a081fc9a5ea061da$var$isArray(value)) {
                let subRecords = [];
                const stack = [
                    {
                        nestedArrIndex: -1,
                        value: value
                    }
                ];
                while(stack.length){
                    const { nestedArrIndex: nestedArrIndex, value: value } = stack.pop();
                    if (!$a081fc9a5ea061da$var$isDefined(value)) continue;
                    if ($a081fc9a5ea061da$var$isString(value) && !$a081fc9a5ea061da$var$isBlank(value)) {
                        let subRecord = {
                            v: value,
                            i: nestedArrIndex,
                            n: this.norm.get(value)
                        };
                        subRecords.push(subRecord);
                    } else if ($a081fc9a5ea061da$var$isArray(value)) value.forEach((item, k)=>{
                        stack.push({
                            nestedArrIndex: k,
                            value: item
                        });
                    });
                }
                record.$[keyIndex] = subRecords;
            } else if ($a081fc9a5ea061da$var$isString(value) && !$a081fc9a5ea061da$var$isBlank(value)) {
                let subRecord = {
                    v: value,
                    n: this.norm.get(value)
                };
                record.$[keyIndex] = subRecord;
            }
        });
        this.records.push(record);
    }
    toJSON() {
        return {
            keys: this.keys,
            records: this.records
        };
    }
}
function $a081fc9a5ea061da$var$createIndex(keys, docs, { getFn: getFn = $a081fc9a5ea061da$var$Config.getFn, fieldNormWeight: fieldNormWeight = $a081fc9a5ea061da$var$Config.fieldNormWeight } = {}) {
    const myIndex = new $a081fc9a5ea061da$var$FuseIndex({
        getFn: getFn,
        fieldNormWeight: fieldNormWeight
    });
    myIndex.setKeys(keys.map($a081fc9a5ea061da$var$createKey));
    myIndex.setSources(docs);
    myIndex.create();
    return myIndex;
}
function $a081fc9a5ea061da$var$parseIndex(data, { getFn: getFn = $a081fc9a5ea061da$var$Config.getFn, fieldNormWeight: fieldNormWeight = $a081fc9a5ea061da$var$Config.fieldNormWeight } = {}) {
    const { keys: keys, records: records } = data;
    const myIndex = new $a081fc9a5ea061da$var$FuseIndex({
        getFn: getFn,
        fieldNormWeight: fieldNormWeight
    });
    myIndex.setKeys(keys);
    myIndex.setIndexRecords(records);
    return myIndex;
}
function $a081fc9a5ea061da$var$computeScore$1(pattern, { errors: errors = 0, currentLocation: currentLocation = 0, expectedLocation: expectedLocation = 0, distance: distance = $a081fc9a5ea061da$var$Config.distance, ignoreLocation: ignoreLocation = $a081fc9a5ea061da$var$Config.ignoreLocation } = {}) {
    const accuracy = errors / pattern.length;
    if (ignoreLocation) return accuracy;
    const proximity = Math.abs(expectedLocation - currentLocation);
    if (!distance) // Dodge divide by zero error.
    return proximity ? 1.0 : accuracy;
    return accuracy + proximity / distance;
}
function $a081fc9a5ea061da$var$convertMaskToIndices(matchmask = [], minMatchCharLength = $a081fc9a5ea061da$var$Config.minMatchCharLength) {
    let indices = [];
    let start = -1;
    let end = -1;
    let i = 0;
    for(let len = matchmask.length; i < len; i += 1){
        let match = matchmask[i];
        if (match && start === -1) start = i;
        else if (!match && start !== -1) {
            end = i - 1;
            if (end - start + 1 >= minMatchCharLength) indices.push([
                start,
                end
            ]);
            start = -1;
        }
    }
    // (i-1 - start) + 1 => i - start
    if (matchmask[i - 1] && i - start >= minMatchCharLength) indices.push([
        start,
        i - 1
    ]);
    return indices;
}
// Machine word size
const $a081fc9a5ea061da$var$MAX_BITS = 32;
function $a081fc9a5ea061da$var$search(text, pattern, patternAlphabet, { location: location = $a081fc9a5ea061da$var$Config.location, distance: distance = $a081fc9a5ea061da$var$Config.distance, threshold: threshold = $a081fc9a5ea061da$var$Config.threshold, findAllMatches: findAllMatches = $a081fc9a5ea061da$var$Config.findAllMatches, minMatchCharLength: minMatchCharLength = $a081fc9a5ea061da$var$Config.minMatchCharLength, includeMatches: includeMatches = $a081fc9a5ea061da$var$Config.includeMatches, ignoreLocation: ignoreLocation = $a081fc9a5ea061da$var$Config.ignoreLocation } = {}) {
    if (pattern.length > $a081fc9a5ea061da$var$MAX_BITS) throw new Error($a081fc9a5ea061da$var$PATTERN_LENGTH_TOO_LARGE($a081fc9a5ea061da$var$MAX_BITS));
    const patternLen = pattern.length;
    // Set starting location at beginning text and initialize the alphabet.
    const textLen = text.length;
    // Handle the case when location > text.length
    const expectedLocation = Math.max(0, Math.min(location, textLen));
    // Highest score beyond which we give up.
    let currentThreshold = threshold;
    // Is there a nearby exact match? (speedup)
    let bestLocation = expectedLocation;
    // Performance: only computer matches when the minMatchCharLength > 1
    // OR if `includeMatches` is true.
    const computeMatches = minMatchCharLength > 1 || includeMatches;
    // A mask of the matches, used for building the indices
    const matchMask = computeMatches ? Array(textLen) : [];
    let index;
    // Get all exact matches, here for speed up
    while((index = text.indexOf(pattern, bestLocation)) > -1){
        let score = $a081fc9a5ea061da$var$computeScore$1(pattern, {
            currentLocation: index,
            expectedLocation: expectedLocation,
            distance: distance,
            ignoreLocation: ignoreLocation
        });
        currentThreshold = Math.min(score, currentThreshold);
        bestLocation = index + patternLen;
        if (computeMatches) {
            let i = 0;
            while(i < patternLen){
                matchMask[index + i] = 1;
                i += 1;
            }
        }
    }
    // Reset the best location
    bestLocation = -1;
    let lastBitArr = [];
    let finalScore = 1;
    let binMax = patternLen + textLen;
    const mask = 1 << patternLen - 1;
    for(let i = 0; i < patternLen; i += 1){
        // Scan for the best match; each iteration allows for one more error.
        // Run a binary search to determine how far from the match location we can stray
        // at this error level.
        let binMin = 0;
        let binMid = binMax;
        while(binMin < binMid){
            const score = $a081fc9a5ea061da$var$computeScore$1(pattern, {
                errors: i,
                currentLocation: expectedLocation + binMid,
                expectedLocation: expectedLocation,
                distance: distance,
                ignoreLocation: ignoreLocation
            });
            if (score <= currentThreshold) binMin = binMid;
            else binMax = binMid;
            binMid = Math.floor((binMax - binMin) / 2 + binMin);
        }
        // Use the result from this iteration as the maximum for the next.
        binMax = binMid;
        let start = Math.max(1, expectedLocation - binMid + 1);
        let finish = findAllMatches ? textLen : Math.min(expectedLocation + binMid, textLen) + patternLen;
        // Initialize the bit array
        let bitArr = Array(finish + 2);
        bitArr[finish + 1] = (1 << i) - 1;
        for(let j = finish; j >= start; j -= 1){
            let currentLocation = j - 1;
            let charMatch = patternAlphabet[text.charAt(currentLocation)];
            if (computeMatches) // Speed up: quick bool to int conversion (i.e, `charMatch ? 1 : 0`)
            matchMask[currentLocation] = +!!charMatch;
            // First pass: exact match
            bitArr[j] = (bitArr[j + 1] << 1 | 1) & charMatch;
            // Subsequent passes: fuzzy match
            if (i) bitArr[j] |= (lastBitArr[j + 1] | lastBitArr[j]) << 1 | 1 | lastBitArr[j + 1];
            if (bitArr[j] & mask) {
                finalScore = $a081fc9a5ea061da$var$computeScore$1(pattern, {
                    errors: i,
                    currentLocation: currentLocation,
                    expectedLocation: expectedLocation,
                    distance: distance,
                    ignoreLocation: ignoreLocation
                });
                // This match will almost certainly be better than any existing match.
                // But check anyway.
                if (finalScore <= currentThreshold) {
                    // Indeed it is
                    currentThreshold = finalScore;
                    bestLocation = currentLocation;
                    // Already passed `loc`, downhill from here on in.
                    if (bestLocation <= expectedLocation) break;
                    // When passing `bestLocation`, don't exceed our current distance from `expectedLocation`.
                    start = Math.max(1, 2 * expectedLocation - bestLocation);
                }
            }
        }
        // No hope for a (better) match at greater error levels.
        const score = $a081fc9a5ea061da$var$computeScore$1(pattern, {
            errors: i + 1,
            currentLocation: expectedLocation,
            expectedLocation: expectedLocation,
            distance: distance,
            ignoreLocation: ignoreLocation
        });
        if (score > currentThreshold) break;
        lastBitArr = bitArr;
    }
    const result = {
        isMatch: bestLocation >= 0,
        // Count exact matches (those with a score of 0) to be "almost" exact
        score: Math.max(0.001, finalScore)
    };
    if (computeMatches) {
        const indices = $a081fc9a5ea061da$var$convertMaskToIndices(matchMask, minMatchCharLength);
        if (!indices.length) result.isMatch = false;
        else if (includeMatches) result.indices = indices;
    }
    return result;
}
function $a081fc9a5ea061da$var$createPatternAlphabet(pattern) {
    let mask = {};
    for(let i = 0, len = pattern.length; i < len; i += 1){
        const char = pattern.charAt(i);
        mask[char] = (mask[char] || 0) | 1 << len - i - 1;
    }
    return mask;
}
class $a081fc9a5ea061da$var$BitapSearch {
    constructor(pattern, { location: location = $a081fc9a5ea061da$var$Config.location, threshold: threshold = $a081fc9a5ea061da$var$Config.threshold, distance: distance = $a081fc9a5ea061da$var$Config.distance, includeMatches: includeMatches = $a081fc9a5ea061da$var$Config.includeMatches, findAllMatches: findAllMatches = $a081fc9a5ea061da$var$Config.findAllMatches, minMatchCharLength: minMatchCharLength = $a081fc9a5ea061da$var$Config.minMatchCharLength, isCaseSensitive: isCaseSensitive = $a081fc9a5ea061da$var$Config.isCaseSensitive, ignoreLocation: ignoreLocation = $a081fc9a5ea061da$var$Config.ignoreLocation } = {}){
        this.options = {
            location: location,
            threshold: threshold,
            distance: distance,
            includeMatches: includeMatches,
            findAllMatches: findAllMatches,
            minMatchCharLength: minMatchCharLength,
            isCaseSensitive: isCaseSensitive,
            ignoreLocation: ignoreLocation
        };
        this.pattern = isCaseSensitive ? pattern : pattern.toLowerCase();
        this.chunks = [];
        if (!this.pattern.length) return;
        const addChunk = (pattern, startIndex)=>{
            this.chunks.push({
                pattern: pattern,
                alphabet: $a081fc9a5ea061da$var$createPatternAlphabet(pattern),
                startIndex: startIndex
            });
        };
        const len = this.pattern.length;
        if (len > $a081fc9a5ea061da$var$MAX_BITS) {
            let i = 0;
            const remainder = len % $a081fc9a5ea061da$var$MAX_BITS;
            const end = len - remainder;
            while(i < end){
                addChunk(this.pattern.substr(i, $a081fc9a5ea061da$var$MAX_BITS), i);
                i += $a081fc9a5ea061da$var$MAX_BITS;
            }
            if (remainder) {
                const startIndex = len - $a081fc9a5ea061da$var$MAX_BITS;
                addChunk(this.pattern.substr(startIndex), startIndex);
            }
        } else addChunk(this.pattern, 0);
    }
    searchIn(text) {
        const { isCaseSensitive: isCaseSensitive, includeMatches: includeMatches } = this.options;
        if (!isCaseSensitive) text = text.toLowerCase();
        // Exact match
        if (this.pattern === text) {
            let result = {
                isMatch: true,
                score: 0
            };
            if (includeMatches) result.indices = [
                [
                    0,
                    text.length - 1
                ]
            ];
            return result;
        }
        // Otherwise, use Bitap algorithm
        const { location: location, distance: distance, threshold: threshold, findAllMatches: findAllMatches, minMatchCharLength: minMatchCharLength, ignoreLocation: ignoreLocation } = this.options;
        let allIndices = [];
        let totalScore = 0;
        let hasMatches = false;
        this.chunks.forEach(({ pattern: pattern, alphabet: alphabet, startIndex: startIndex })=>{
            const { isMatch: isMatch, score: score, indices: indices } = $a081fc9a5ea061da$var$search(text, pattern, alphabet, {
                location: location + startIndex,
                distance: distance,
                threshold: threshold,
                findAllMatches: findAllMatches,
                minMatchCharLength: minMatchCharLength,
                includeMatches: includeMatches,
                ignoreLocation: ignoreLocation
            });
            if (isMatch) hasMatches = true;
            totalScore += score;
            if (isMatch && indices) allIndices = [
                ...allIndices,
                ...indices
            ];
        });
        let result = {
            isMatch: hasMatches,
            score: hasMatches ? totalScore / this.chunks.length : 1
        };
        if (hasMatches && includeMatches) result.indices = allIndices;
        return result;
    }
}
class $a081fc9a5ea061da$var$BaseMatch {
    constructor(pattern){
        this.pattern = pattern;
    }
    static isMultiMatch(pattern) {
        return $a081fc9a5ea061da$var$getMatch(pattern, this.multiRegex);
    }
    static isSingleMatch(pattern) {
        return $a081fc9a5ea061da$var$getMatch(pattern, this.singleRegex);
    }
    search() {}
}
function $a081fc9a5ea061da$var$getMatch(pattern, exp) {
    const matches = pattern.match(exp);
    return matches ? matches[1] : null;
}
// Token: 'file
class $a081fc9a5ea061da$var$ExactMatch extends $a081fc9a5ea061da$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return 'exact';
    }
    static get multiRegex() {
        return /^="(.*)"$/;
    }
    static get singleRegex() {
        return /^=(.*)$/;
    }
    search(text) {
        const isMatch = text === this.pattern;
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                this.pattern.length - 1
            ]
        };
    }
}
// Token: !fire
class $a081fc9a5ea061da$var$InverseExactMatch extends $a081fc9a5ea061da$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return 'inverse-exact';
    }
    static get multiRegex() {
        return /^!"(.*)"$/;
    }
    static get singleRegex() {
        return /^!(.*)$/;
    }
    search(text) {
        const index = text.indexOf(this.pattern);
        const isMatch = index === -1;
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                text.length - 1
            ]
        };
    }
}
// Token: ^file
class $a081fc9a5ea061da$var$PrefixExactMatch extends $a081fc9a5ea061da$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return 'prefix-exact';
    }
    static get multiRegex() {
        return /^\^"(.*)"$/;
    }
    static get singleRegex() {
        return /^\^(.*)$/;
    }
    search(text) {
        const isMatch = text.startsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                this.pattern.length - 1
            ]
        };
    }
}
// Token: !^fire
class $a081fc9a5ea061da$var$InversePrefixExactMatch extends $a081fc9a5ea061da$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return 'inverse-prefix-exact';
    }
    static get multiRegex() {
        return /^!\^"(.*)"$/;
    }
    static get singleRegex() {
        return /^!\^(.*)$/;
    }
    search(text) {
        const isMatch = !text.startsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                text.length - 1
            ]
        };
    }
}
// Token: .file$
class $a081fc9a5ea061da$var$SuffixExactMatch extends $a081fc9a5ea061da$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return 'suffix-exact';
    }
    static get multiRegex() {
        return /^"(.*)"\$$/;
    }
    static get singleRegex() {
        return /^(.*)\$$/;
    }
    search(text) {
        const isMatch = text.endsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                text.length - this.pattern.length,
                text.length - 1
            ]
        };
    }
}
// Token: !.file$
class $a081fc9a5ea061da$var$InverseSuffixExactMatch extends $a081fc9a5ea061da$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return 'inverse-suffix-exact';
    }
    static get multiRegex() {
        return /^!"(.*)"\$$/;
    }
    static get singleRegex() {
        return /^!(.*)\$$/;
    }
    search(text) {
        const isMatch = !text.endsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                text.length - 1
            ]
        };
    }
}
class $a081fc9a5ea061da$var$FuzzyMatch extends $a081fc9a5ea061da$var$BaseMatch {
    constructor(pattern, { location: location = $a081fc9a5ea061da$var$Config.location, threshold: threshold = $a081fc9a5ea061da$var$Config.threshold, distance: distance = $a081fc9a5ea061da$var$Config.distance, includeMatches: includeMatches = $a081fc9a5ea061da$var$Config.includeMatches, findAllMatches: findAllMatches = $a081fc9a5ea061da$var$Config.findAllMatches, minMatchCharLength: minMatchCharLength = $a081fc9a5ea061da$var$Config.minMatchCharLength, isCaseSensitive: isCaseSensitive = $a081fc9a5ea061da$var$Config.isCaseSensitive, ignoreLocation: ignoreLocation = $a081fc9a5ea061da$var$Config.ignoreLocation } = {}){
        super(pattern);
        this._bitapSearch = new $a081fc9a5ea061da$var$BitapSearch(pattern, {
            location: location,
            threshold: threshold,
            distance: distance,
            includeMatches: includeMatches,
            findAllMatches: findAllMatches,
            minMatchCharLength: minMatchCharLength,
            isCaseSensitive: isCaseSensitive,
            ignoreLocation: ignoreLocation
        });
    }
    static get type() {
        return 'fuzzy';
    }
    static get multiRegex() {
        return /^"(.*)"$/;
    }
    static get singleRegex() {
        return /^(.*)$/;
    }
    search(text) {
        return this._bitapSearch.searchIn(text);
    }
}
// Token: 'file
class $a081fc9a5ea061da$var$IncludeMatch extends $a081fc9a5ea061da$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return 'include';
    }
    static get multiRegex() {
        return /^'"(.*)"$/;
    }
    static get singleRegex() {
        return /^'(.*)$/;
    }
    search(text) {
        let location = 0;
        let index;
        const indices = [];
        const patternLen = this.pattern.length;
        // Get all exact matches
        while((index = text.indexOf(this.pattern, location)) > -1){
            location = index + patternLen;
            indices.push([
                index,
                location - 1
            ]);
        }
        const isMatch = !!indices.length;
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: indices
        };
    }
}
// ❗Order is important. DO NOT CHANGE.
const $a081fc9a5ea061da$var$searchers = [
    $a081fc9a5ea061da$var$ExactMatch,
    $a081fc9a5ea061da$var$IncludeMatch,
    $a081fc9a5ea061da$var$PrefixExactMatch,
    $a081fc9a5ea061da$var$InversePrefixExactMatch,
    $a081fc9a5ea061da$var$InverseSuffixExactMatch,
    $a081fc9a5ea061da$var$SuffixExactMatch,
    $a081fc9a5ea061da$var$InverseExactMatch,
    $a081fc9a5ea061da$var$FuzzyMatch
];
const $a081fc9a5ea061da$var$searchersLen = $a081fc9a5ea061da$var$searchers.length;
// Regex to split by spaces, but keep anything in quotes together
const $a081fc9a5ea061da$var$SPACE_RE = / +(?=(?:[^\"]*\"[^\"]*\")*[^\"]*$)/;
const $a081fc9a5ea061da$var$OR_TOKEN = '|';
// Return a 2D array representation of the query, for simpler parsing.
// Example:
// "^core go$ | rb$ | py$ xy$" => [["^core", "go$"], ["rb$"], ["py$", "xy$"]]
function $a081fc9a5ea061da$var$parseQuery(pattern, options = {}) {
    return pattern.split($a081fc9a5ea061da$var$OR_TOKEN).map((item)=>{
        let query = item.trim().split($a081fc9a5ea061da$var$SPACE_RE).filter((item)=>item && !!item.trim());
        let results = [];
        for(let i = 0, len = query.length; i < len; i += 1){
            const queryItem = query[i];
            // 1. Handle multiple query match (i.e, once that are quoted, like `"hello world"`)
            let found = false;
            let idx = -1;
            while(!found && ++idx < $a081fc9a5ea061da$var$searchersLen){
                const searcher = $a081fc9a5ea061da$var$searchers[idx];
                let token = searcher.isMultiMatch(queryItem);
                if (token) {
                    results.push(new searcher(token, options));
                    found = true;
                }
            }
            if (found) continue;
            // 2. Handle single query matches (i.e, once that are *not* quoted)
            idx = -1;
            while(++idx < $a081fc9a5ea061da$var$searchersLen){
                const searcher = $a081fc9a5ea061da$var$searchers[idx];
                let token = searcher.isSingleMatch(queryItem);
                if (token) {
                    results.push(new searcher(token, options));
                    break;
                }
            }
        }
        return results;
    });
}
// These extended matchers can return an array of matches, as opposed
// to a singl match
const $a081fc9a5ea061da$var$MultiMatchSet = new Set([
    $a081fc9a5ea061da$var$FuzzyMatch.type,
    $a081fc9a5ea061da$var$IncludeMatch.type
]);
/**
 * Command-like searching
 * ======================
 *
 * Given multiple search terms delimited by spaces.e.g. `^jscript .python$ ruby !java`,
 * search in a given text.
 *
 * Search syntax:
 *
 * | Token       | Match type                 | Description                            |
 * | ----------- | -------------------------- | -------------------------------------- |
 * | `jscript`   | fuzzy-match                | Items that fuzzy match `jscript`       |
 * | `=scheme`   | exact-match                | Items that are `scheme`                |
 * | `'python`   | include-match              | Items that include `python`            |
 * | `!ruby`     | inverse-exact-match        | Items that do not include `ruby`       |
 * | `^java`     | prefix-exact-match         | Items that start with `java`           |
 * | `!^earlang` | inverse-prefix-exact-match | Items that do not start with `earlang` |
 * | `.js$`      | suffix-exact-match         | Items that end with `.js`              |
 * | `!.go$`     | inverse-suffix-exact-match | Items that do not end with `.go`       |
 *
 * A single pipe character acts as an OR operator. For example, the following
 * query matches entries that start with `core` and end with either`go`, `rb`,
 * or`py`.
 *
 * ```
 * ^core go$ | rb$ | py$
 * ```
 */ class $a081fc9a5ea061da$var$ExtendedSearch {
    constructor(pattern, { isCaseSensitive: isCaseSensitive = $a081fc9a5ea061da$var$Config.isCaseSensitive, includeMatches: includeMatches = $a081fc9a5ea061da$var$Config.includeMatches, minMatchCharLength: minMatchCharLength = $a081fc9a5ea061da$var$Config.minMatchCharLength, ignoreLocation: ignoreLocation = $a081fc9a5ea061da$var$Config.ignoreLocation, findAllMatches: findAllMatches = $a081fc9a5ea061da$var$Config.findAllMatches, location: location = $a081fc9a5ea061da$var$Config.location, threshold: threshold = $a081fc9a5ea061da$var$Config.threshold, distance: distance = $a081fc9a5ea061da$var$Config.distance } = {}){
        this.query = null;
        this.options = {
            isCaseSensitive: isCaseSensitive,
            includeMatches: includeMatches,
            minMatchCharLength: minMatchCharLength,
            findAllMatches: findAllMatches,
            ignoreLocation: ignoreLocation,
            location: location,
            threshold: threshold,
            distance: distance
        };
        this.pattern = isCaseSensitive ? pattern : pattern.toLowerCase();
        this.query = $a081fc9a5ea061da$var$parseQuery(this.pattern, this.options);
    }
    static condition(_, options) {
        return options.useExtendedSearch;
    }
    searchIn(text) {
        const query = this.query;
        if (!query) return {
            isMatch: false,
            score: 1
        };
        const { includeMatches: includeMatches, isCaseSensitive: isCaseSensitive } = this.options;
        text = isCaseSensitive ? text : text.toLowerCase();
        let numMatches = 0;
        let allIndices = [];
        let totalScore = 0;
        // ORs
        for(let i = 0, qLen = query.length; i < qLen; i += 1){
            const searchers = query[i];
            // Reset indices
            allIndices.length = 0;
            numMatches = 0;
            // ANDs
            for(let j = 0, pLen = searchers.length; j < pLen; j += 1){
                const searcher = searchers[j];
                const { isMatch: isMatch, indices: indices, score: score } = searcher.search(text);
                if (isMatch) {
                    numMatches += 1;
                    totalScore += score;
                    if (includeMatches) {
                        const type = searcher.constructor.type;
                        if ($a081fc9a5ea061da$var$MultiMatchSet.has(type)) allIndices = [
                            ...allIndices,
                            ...indices
                        ];
                        else allIndices.push(indices);
                    }
                } else {
                    totalScore = 0;
                    numMatches = 0;
                    allIndices.length = 0;
                    break;
                }
            }
            // OR condition, so if TRUE, return
            if (numMatches) {
                let result = {
                    isMatch: true,
                    score: totalScore / numMatches
                };
                if (includeMatches) result.indices = allIndices;
                return result;
            }
        }
        // Nothing was matched
        return {
            isMatch: false,
            score: 1
        };
    }
}
const $a081fc9a5ea061da$var$registeredSearchers = [];
function $a081fc9a5ea061da$var$register(...args) {
    $a081fc9a5ea061da$var$registeredSearchers.push(...args);
}
function $a081fc9a5ea061da$var$createSearcher(pattern, options) {
    for(let i = 0, len = $a081fc9a5ea061da$var$registeredSearchers.length; i < len; i += 1){
        let searcherClass = $a081fc9a5ea061da$var$registeredSearchers[i];
        if (searcherClass.condition(pattern, options)) return new searcherClass(pattern, options);
    }
    return new $a081fc9a5ea061da$var$BitapSearch(pattern, options);
}
const $a081fc9a5ea061da$var$LogicalOperator = {
    AND: '$and',
    OR: '$or'
};
const $a081fc9a5ea061da$var$KeyType = {
    PATH: '$path',
    PATTERN: '$val'
};
const $a081fc9a5ea061da$var$isExpression = (query)=>!!(query[$a081fc9a5ea061da$var$LogicalOperator.AND] || query[$a081fc9a5ea061da$var$LogicalOperator.OR]);
const $a081fc9a5ea061da$var$isPath = (query)=>!!query[$a081fc9a5ea061da$var$KeyType.PATH];
const $a081fc9a5ea061da$var$isLeaf = (query)=>!$a081fc9a5ea061da$var$isArray(query) && $a081fc9a5ea061da$var$isObject(query) && !$a081fc9a5ea061da$var$isExpression(query);
const $a081fc9a5ea061da$var$convertToExplicit = (query)=>({
        [$a081fc9a5ea061da$var$LogicalOperator.AND]: Object.keys(query).map((key)=>({
                [key]: query[key]
            }))
    });
// When `auto` is `true`, the parse function will infer and initialize and add
// the appropriate `Searcher` instance
function $a081fc9a5ea061da$var$parse(query, options, { auto: auto = true } = {}) {
    const next = (query)=>{
        let keys = Object.keys(query);
        const isQueryPath = $a081fc9a5ea061da$var$isPath(query);
        if (!isQueryPath && keys.length > 1 && !$a081fc9a5ea061da$var$isExpression(query)) return next($a081fc9a5ea061da$var$convertToExplicit(query));
        if ($a081fc9a5ea061da$var$isLeaf(query)) {
            const key = isQueryPath ? query[$a081fc9a5ea061da$var$KeyType.PATH] : keys[0];
            const pattern = isQueryPath ? query[$a081fc9a5ea061da$var$KeyType.PATTERN] : query[key];
            if (!$a081fc9a5ea061da$var$isString(pattern)) throw new Error($a081fc9a5ea061da$var$LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY(key));
            const obj = {
                keyId: $a081fc9a5ea061da$var$createKeyId(key),
                pattern: pattern
            };
            if (auto) obj.searcher = $a081fc9a5ea061da$var$createSearcher(pattern, options);
            return obj;
        }
        let node = {
            children: [],
            operator: keys[0]
        };
        keys.forEach((key)=>{
            const value = query[key];
            if ($a081fc9a5ea061da$var$isArray(value)) value.forEach((item)=>{
                node.children.push(next(item));
            });
        });
        return node;
    };
    if (!$a081fc9a5ea061da$var$isExpression(query)) query = $a081fc9a5ea061da$var$convertToExplicit(query);
    return next(query);
}
// Practical scoring function
function $a081fc9a5ea061da$var$computeScore(results, { ignoreFieldNorm: ignoreFieldNorm = $a081fc9a5ea061da$var$Config.ignoreFieldNorm }) {
    results.forEach((result)=>{
        let totalScore = 1;
        result.matches.forEach(({ key: key, norm: norm, score: score })=>{
            const weight = key ? key.weight : null;
            totalScore *= Math.pow(score === 0 && weight ? Number.EPSILON : score, (weight || 1) * (ignoreFieldNorm ? 1 : norm));
        });
        result.score = totalScore;
    });
}
function $a081fc9a5ea061da$var$transformMatches(result, data) {
    const matches = result.matches;
    data.matches = [];
    if (!$a081fc9a5ea061da$var$isDefined(matches)) return;
    matches.forEach((match)=>{
        if (!$a081fc9a5ea061da$var$isDefined(match.indices) || !match.indices.length) return;
        const { indices: indices, value: value } = match;
        let obj = {
            indices: indices,
            value: value
        };
        if (match.key) obj.key = match.key.src;
        if (match.idx > -1) obj.refIndex = match.idx;
        data.matches.push(obj);
    });
}
function $a081fc9a5ea061da$var$transformScore(result, data) {
    data.score = result.score;
}
function $a081fc9a5ea061da$var$format(results, docs, { includeMatches: includeMatches = $a081fc9a5ea061da$var$Config.includeMatches, includeScore: includeScore = $a081fc9a5ea061da$var$Config.includeScore } = {}) {
    const transformers = [];
    if (includeMatches) transformers.push($a081fc9a5ea061da$var$transformMatches);
    if (includeScore) transformers.push($a081fc9a5ea061da$var$transformScore);
    return results.map((result)=>{
        const { idx: idx } = result;
        const data = {
            item: docs[idx],
            refIndex: idx
        };
        if (transformers.length) transformers.forEach((transformer)=>{
            transformer(result, data);
        });
        return data;
    });
}
class $a081fc9a5ea061da$export$2e2bcd8739ae039 {
    constructor(docs, options = {}, index){
        this.options = {
            ...$a081fc9a5ea061da$var$Config,
            ...options
        };
        this.options.useExtendedSearch;
        this._keyStore = new $a081fc9a5ea061da$var$KeyStore(this.options.keys);
        this.setCollection(docs, index);
    }
    setCollection(docs, index) {
        this._docs = docs;
        if (index && !(index instanceof $a081fc9a5ea061da$var$FuseIndex)) throw new Error($a081fc9a5ea061da$var$INCORRECT_INDEX_TYPE);
        this._myIndex = index || $a081fc9a5ea061da$var$createIndex(this.options.keys, this._docs, {
            getFn: this.options.getFn,
            fieldNormWeight: this.options.fieldNormWeight
        });
    }
    add(doc) {
        if (!$a081fc9a5ea061da$var$isDefined(doc)) return;
        this._docs.push(doc);
        this._myIndex.add(doc);
    }
    remove(predicate = ()=>false) {
        const results = [];
        for(let i = 0, len = this._docs.length; i < len; i += 1){
            const doc = this._docs[i];
            if (predicate(doc, i)) {
                this.removeAt(i);
                i -= 1;
                len -= 1;
                results.push(doc);
            }
        }
        return results;
    }
    removeAt(idx) {
        this._docs.splice(idx, 1);
        this._myIndex.removeAt(idx);
    }
    getIndex() {
        return this._myIndex;
    }
    search(query, { limit: limit = -1 } = {}) {
        const { includeMatches: includeMatches, includeScore: includeScore, shouldSort: shouldSort, sortFn: sortFn, ignoreFieldNorm: ignoreFieldNorm } = this.options;
        let results = $a081fc9a5ea061da$var$isString(query) ? $a081fc9a5ea061da$var$isString(this._docs[0]) ? this._searchStringList(query) : this._searchObjectList(query) : this._searchLogical(query);
        $a081fc9a5ea061da$var$computeScore(results, {
            ignoreFieldNorm: ignoreFieldNorm
        });
        if (shouldSort) results.sort(sortFn);
        if ($a081fc9a5ea061da$var$isNumber(limit) && limit > -1) results = results.slice(0, limit);
        return $a081fc9a5ea061da$var$format(results, this._docs, {
            includeMatches: includeMatches,
            includeScore: includeScore
        });
    }
    _searchStringList(query) {
        const searcher = $a081fc9a5ea061da$var$createSearcher(query, this.options);
        const { records: records } = this._myIndex;
        const results = [];
        // Iterate over every string in the index
        records.forEach(({ v: text, i: idx, n: norm })=>{
            if (!$a081fc9a5ea061da$var$isDefined(text)) return;
            const { isMatch: isMatch, score: score, indices: indices } = searcher.searchIn(text);
            if (isMatch) results.push({
                item: text,
                idx: idx,
                matches: [
                    {
                        score: score,
                        value: text,
                        norm: norm,
                        indices: indices
                    }
                ]
            });
        });
        return results;
    }
    _searchLogical(query) {
        const expression = $a081fc9a5ea061da$var$parse(query, this.options);
        const evaluate = (node, item, idx)=>{
            if (!node.children) {
                const { keyId: keyId, searcher: searcher } = node;
                const matches = this._findMatches({
                    key: this._keyStore.get(keyId),
                    value: this._myIndex.getValueForItemAtKeyId(item, keyId),
                    searcher: searcher
                });
                if (matches && matches.length) return [
                    {
                        idx: idx,
                        item: item,
                        matches: matches
                    }
                ];
                return [];
            }
            const res = [];
            for(let i = 0, len = node.children.length; i < len; i += 1){
                const child = node.children[i];
                const result = evaluate(child, item, idx);
                if (result.length) res.push(...result);
                else if (node.operator === $a081fc9a5ea061da$var$LogicalOperator.AND) return [];
            }
            return res;
        };
        const records = this._myIndex.records;
        const resultMap = {};
        const results = [];
        records.forEach(({ $: item, i: idx })=>{
            if ($a081fc9a5ea061da$var$isDefined(item)) {
                let expResults = evaluate(expression, item, idx);
                if (expResults.length) {
                    // Dedupe when adding
                    if (!resultMap[idx]) {
                        resultMap[idx] = {
                            idx: idx,
                            item: item,
                            matches: []
                        };
                        results.push(resultMap[idx]);
                    }
                    expResults.forEach(({ matches: matches })=>{
                        resultMap[idx].matches.push(...matches);
                    });
                }
            }
        });
        return results;
    }
    _searchObjectList(query) {
        const searcher = $a081fc9a5ea061da$var$createSearcher(query, this.options);
        const { keys: keys, records: records } = this._myIndex;
        const results = [];
        // List is Array<Object>
        records.forEach(({ $: item, i: idx })=>{
            if (!$a081fc9a5ea061da$var$isDefined(item)) return;
            let matches = [];
            // Iterate over every key (i.e, path), and fetch the value at that key
            keys.forEach((key, keyIndex)=>{
                matches.push(...this._findMatches({
                    key: key,
                    value: item[keyIndex],
                    searcher: searcher
                }));
            });
            if (matches.length) results.push({
                idx: idx,
                item: item,
                matches: matches
            });
        });
        return results;
    }
    _findMatches({ key: key, value: value, searcher: searcher }) {
        if (!$a081fc9a5ea061da$var$isDefined(value)) return [];
        let matches = [];
        if ($a081fc9a5ea061da$var$isArray(value)) value.forEach(({ v: text, i: idx, n: norm })=>{
            if (!$a081fc9a5ea061da$var$isDefined(text)) return;
            const { isMatch: isMatch, score: score, indices: indices } = searcher.searchIn(text);
            if (isMatch) matches.push({
                score: score,
                key: key,
                value: text,
                idx: idx,
                norm: norm,
                indices: indices
            });
        });
        else {
            const { v: text, n: norm } = value;
            const { isMatch: isMatch, score: score, indices: indices } = searcher.searchIn(text);
            if (isMatch) matches.push({
                score: score,
                key: key,
                value: text,
                norm: norm,
                indices: indices
            });
        }
        return matches;
    }
}
$a081fc9a5ea061da$export$2e2bcd8739ae039.version = '6.6.2';
$a081fc9a5ea061da$export$2e2bcd8739ae039.createIndex = $a081fc9a5ea061da$var$createIndex;
$a081fc9a5ea061da$export$2e2bcd8739ae039.parseIndex = $a081fc9a5ea061da$var$parseIndex;
$a081fc9a5ea061da$export$2e2bcd8739ae039.config = $a081fc9a5ea061da$var$Config;
$a081fc9a5ea061da$export$2e2bcd8739ae039.parseQuery = $a081fc9a5ea061da$var$parse;
$a081fc9a5ea061da$var$register($a081fc9a5ea061da$var$ExtendedSearch);

});

parcelRegister("8RCag", function(module, exports) {

$parcel$export(module.exports, "createPagination", () => $6740e0a46ade6de7$export$7f3155e3cda021fd);

var $b4xNq = parcelRequire("b4xNq");
"use strict";
const $6740e0a46ade6de7$var$movieContainer = document.querySelector(".movie-container");
let $6740e0a46ade6de7$var$currentPage;
const $6740e0a46ade6de7$export$7f3155e3cda021fd = (arr, page, start = 'Start', end = 'Ende', next = 'Weiter', back = "Zur\xfcck")=>{
    const paginationContainer = document.createElement('div');
    paginationContainer.className = "pagination-container";
    const pageNumbers = document.createElement('div');
    pageNumbers.className = "page-numbers";
    $6740e0a46ade6de7$var$currentPage = page;
    let maxItems = 25;
    let pageCount = Math.ceil(arr.length / maxItems);
    const startBtn = document.createElement('button');
    startBtn.className = "label-btn start";
    startBtn.textContent = start;
    const firstPage = ()=>{
        $6740e0a46ade6de7$var$currentPage = 1;
        $6740e0a46ade6de7$var$movieContainer.replaceChildren((0, $b4xNq.renderMovies)(arr, 1));
        let currentButton = document.querySelector('.btn-active');
        currentButton.classList.remove('btn-active');
        currentButton.disabled = false;
        let firstPageButton = document.querySelectorAll('.page-btn')[0];
        firstPageButton.classList.add('btn-active');
        startBtn.disabled = true;
        backBtn.disabled = true;
        nextBtn.disabled = false;
        endBtn.disabled = false;
        window.scrollTo(0, 0, 'smooth');
    };
    paginationContainer.appendChild(startBtn);
    startBtn.addEventListener('click', firstPage);
    startBtn.disabled = true;
    const backBtn = document.createElement('button');
    backBtn.className = "label-btn back";
    backBtn.textContent = back;
    const previousPage = ()=>{
        $6740e0a46ade6de7$var$currentPage = $6740e0a46ade6de7$var$currentPage - 1;
        $6740e0a46ade6de7$var$movieContainer.replaceChildren((0, $b4xNq.renderMovies)(arr, $6740e0a46ade6de7$var$currentPage));
        let currentButton = document.querySelector('.btn-active');
        currentButton.classList.remove('btn-active');
        currentButton.disabled = false;
        let newActiveButton = document.querySelectorAll('.page-btn')[$6740e0a46ade6de7$var$currentPage - 1];
        newActiveButton.classList.add('btn-active');
        newActiveButton.disabled = true;
        nextBtn.disabled = false;
        endBtn.disabled = false;
        if ($6740e0a46ade6de7$var$currentPage == 1) {
            startBtn.disabled = true;
            backBtn.disabled = true;
        }
        $6740e0a46ade6de7$var$scrollToTop();
    };
    paginationContainer.appendChild(backBtn);
    backBtn.addEventListener('click', previousPage);
    backBtn.disabled = true;
    const nextBtn = document.createElement('button');
    nextBtn.className = "label-btn next";
    nextBtn.textContent = next;
    const nextPage = ()=>{
        // muss richtig sein 
        $6740e0a46ade6de7$var$currentPage = $6740e0a46ade6de7$var$currentPage + 1;
        $6740e0a46ade6de7$var$movieContainer.replaceChildren((0, $b4xNq.renderMovies)(arr, $6740e0a46ade6de7$var$currentPage));
        let currentButton = document.querySelector('.btn-active');
        currentButton.classList.remove('btn-active');
        currentButton.disabled = false;
        let newActiveButton = document.querySelectorAll('.page-btn')[$6740e0a46ade6de7$var$currentPage - 1];
        newActiveButton.classList.add('btn-active');
        newActiveButton.disabled = true;
        startBtn.disabled = false;
        backBtn.disabled = false;
        if ($6740e0a46ade6de7$var$currentPage == pageCount) {
            nextBtn.disabled = true;
            endBtn.disabled = true;
        }
        $6740e0a46ade6de7$var$scrollToTop();
    };
    paginationContainer.appendChild(nextBtn);
    nextBtn.addEventListener('click', nextPage);
    const endBtn = document.createElement('button');
    endBtn.className = "label-btn end";
    endBtn.textContent = end;
    const lastPage = ()=>{
        $6740e0a46ade6de7$var$currentPage = pageCount;
        $6740e0a46ade6de7$var$movieContainer.replaceChildren((0, $b4xNq.renderMovies)(arr, $6740e0a46ade6de7$var$currentPage));
        let currentButton = document.querySelector('.btn-active');
        currentButton.classList.remove('btn-active');
        currentButton.disabled = false;
        let lastPageButton = document.querySelectorAll('.page-btn')[$6740e0a46ade6de7$var$currentPage - 1];
        lastPageButton.classList.add('btn-active');
        nextBtn.disabled = true;
        endBtn.disabled = true;
        startBtn.disabled = false;
        backBtn.disabled = false;
        $6740e0a46ade6de7$var$scrollToTop();
    };
    paginationContainer.appendChild(endBtn);
    endBtn.addEventListener('click', lastPage);
    for(let i = 1; i < pageCount + 1; i++){
        let btn = $6740e0a46ade6de7$var$PaginationButton(arr, i, startBtn, backBtn, nextBtn, endBtn, pageCount);
        pageNumbers.appendChild(btn);
    }
    paginationContainer.appendChild(pageNumbers);
    return paginationContainer;
};
const $6740e0a46ade6de7$var$PaginationButton = (arr, page, startBtn, backBtn, nextBtn, endBtn, pageCount)=>{
    let pageButton = document.createElement('button');
    pageButton.textContent = page;
    pageButton.className = "page-btn";
    if ($6740e0a46ade6de7$var$currentPage === page) pageButton.classList.add('btn-active');
    pageButton.addEventListener('click', ()=>{
        $6740e0a46ade6de7$var$scrollToTop();
        $6740e0a46ade6de7$var$currentPage = page;
        console.log($6740e0a46ade6de7$var$currentPage);
        if ($6740e0a46ade6de7$var$currentPage === 1) {
            startBtn.disabled = true;
            backBtn.disabled = true;
        }
        if ($6740e0a46ade6de7$var$currentPage > 1) {
            startBtn.disabled = false;
            backBtn.disabled = false;
        }
        if ($6740e0a46ade6de7$var$currentPage === pageCount) {
            nextBtn.disabled = true;
            endBtn.disabled = true;
        }
        if ($6740e0a46ade6de7$var$currentPage < pageCount) {
            nextBtn.disabled = false;
            endBtn.disabled = false;
        }
        $6740e0a46ade6de7$var$movieContainer.replaceChildren((0, $b4xNq.renderMovies)(arr, $6740e0a46ade6de7$var$currentPage));
        let currentButton = document.querySelector('.btn-active');
        currentButton.classList.remove('btn-active');
        currentButton.disabled = false;
        if ($6740e0a46ade6de7$var$currentPage) {
            let newPageButton = pageButton;
            newPageButton.classList.add('btn-active');
            console.log(newPageButton);
            newPageButton.disabled = true;
        }
    });
    return pageButton;
};
const $6740e0a46ade6de7$var$scrollToTop = ()=>{
    window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
    });
};

});

parcelRegister("hrsDh", function(module, exports) {

$parcel$export(module.exports, "sortMovies", () => $cb2b2b223d3c315a$export$a4c4b033c022d22d);

var $8RCag = parcelRequire("8RCag");

var $b4xNq = parcelRequire("b4xNq");
'use strict';
const $cb2b2b223d3c315a$var$pagination = document.querySelector('#pagination');
const $cb2b2b223d3c315a$var$selectComp = document.querySelector('#select');
const $cb2b2b223d3c315a$var$movieContainer = document.querySelector(".movie-container");
// title
const $cb2b2b223d3c315a$var$sortByTitle = (arr)=>{
    return arr.sort((a, b)=>{
        let fa = a.title.toLowerCase(), fb = b.title.toLowerCase();
        if (fa < fb) return -1;
        if (fa > fb) return 1;
        return 0;
    });
};
// director
const $cb2b2b223d3c315a$var$sortByDirector = (arr)=>{
    return arr.sort((a, b)=>{
        let fa = a.director.toLowerCase(), fb = b.director.toLowerCase();
        if (fa < fb) return -1;
        if (fa > fb) return 1;
        return 0;
    });
};
// year
const $cb2b2b223d3c315a$var$sortByReleaseYear = (arr)=>{
    arr.sort((a, b)=>{
        return a.releaseYear - b.releaseYear;
    });
};
// length
const $cb2b2b223d3c315a$var$sortByRuntime = (arr)=>{
    arr.sort((a, b)=>{
        return a.runtime - b.runtime;
    });
};
// date
// const createDates = (arr) => {
//     const timerStart = Date.now();
//     arr[0].map(ele => {
//         const dateArr = [];
//         const day = ele.screeningDate.split('').slice(0, 2).join('');
//         const month = ele.screeningDate.split('').slice(3, 5).join('');
//         const year = ele.screeningDate.split('').slice(6, 10).join('');
//         dateArr.push(year, month, day);
//         let legitDate = dateArr.join('-');
//         const date = new Date(legitDate);
//         console.log(date);
//     });
//     const duration = Date.now() - timerStart;
//     console.log(`duration: ${duration}`);
// }
const $cb2b2b223d3c315a$var$sortByDate = (arr)=>{
    arr.sort((a, b)=>{
        return new Date(a.readableDate) - new Date(b.readableDate);
    });
};
const $cb2b2b223d3c315a$export$a4c4b033c022d22d = (arr, value)=>{
    const sortValue = value;
    switch(sortValue){
        case 'title':
            $cb2b2b223d3c315a$var$sortByTitle(arr);
            // console.log(arr);
            $cb2b2b223d3c315a$var$movieContainer.replaceChildren((0, $b4xNq.renderMovies)(arr));
            $cb2b2b223d3c315a$var$pagination.replaceChildren((0, $8RCag.createPagination)(arr, 1));
            break;
        case 'length':
            $cb2b2b223d3c315a$var$sortByRuntime(arr);
            // console.log(arr);
            $cb2b2b223d3c315a$var$movieContainer.replaceChildren((0, $b4xNq.renderMovies)(arr));
            $cb2b2b223d3c315a$var$pagination.replaceChildren((0, $8RCag.createPagination)(arr, 1));
            break;
        case 'releaseYear':
            $cb2b2b223d3c315a$var$sortByReleaseYear(arr);
            // console.log(arr);
            $cb2b2b223d3c315a$var$movieContainer.replaceChildren((0, $b4xNq.renderMovies)(arr));
            $cb2b2b223d3c315a$var$pagination.replaceChildren((0, $8RCag.createPagination)(arr, 1));
            break;
        case 'director':
            $cb2b2b223d3c315a$var$sortByDirector(arr);
            // console.log(arr);
            $cb2b2b223d3c315a$var$movieContainer.replaceChildren((0, $b4xNq.renderMovies)(arr));
            $cb2b2b223d3c315a$var$pagination.replaceChildren((0, $8RCag.createPagination)(arr, 1));
            break;
        case 'screeningDate':
            $cb2b2b223d3c315a$var$sortByDate(arr);
            // console.log(arr);
            $cb2b2b223d3c315a$var$movieContainer.replaceChildren((0, $b4xNq.renderMovies)(arr));
            $cb2b2b223d3c315a$var$pagination.replaceChildren((0, $8RCag.createPagination)(arr, 1));
            break;
    }
};

});


//# sourceMappingURL=filmarchiv.aa823e73.js.map
